var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.cardInfo)?_c(_setup.MultiJumpContainer,{attrs:{"biTag":_vm.cardInfo.title,"jumpInfo":{
    jumpUrl: _setup.getJumpUrl(_vm.cardInfo),
    appid: _vm.cardInfo.appid,
    username: _vm.cardInfo.username,
    path: _vm.cardInfo.path,
  },"extraData":_vm.cardInfo.customEventKey},on:{"customEventClick":_setup.onClick}},[_c('div',{class:[_setup.isRowCard ? 'theme-row-card-wrapper' : 'theme-card-wrapper']},[_c(_setup.ImageLoader,{staticClass:"logo",attrs:{"src":_vm.cardInfo.logo,"alt":""}}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.cardInfo.title))]),(!_setup.isRowCard && _vm.isShowCardDesc)?_c('div',{staticClass:"desc"},[_vm._v(_vm._s(_vm.cardInfo.desc))]):_vm._e()],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }